import { privateFetch } from "../../utils/CustomFetch"
import { CONSTANT } from "../../utils/Constant"


export const FlowListRequest = async () => {
    let responseData = []
    await privateFetch
        .get(`reply/v1/backoffice/flow`, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        })
        .then(async (response) => {
            responseData = await response.data.data
        })
        .catch((error) => {
            throw new Error(error)
        });

    return responseData
}


export const FlowDataRequest = async (flowId) => {
    let responseData = []
    await privateFetch
        .get(`reply/v1/backoffice/flow/${flowId}/graph`, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        })
        .then(async (response) => {
            responseData = await response.data.data
        })
        .catch((error) => {
            throw new Error(error)
        });

    return responseData
}


export const FlowActivateRequest = async (flowId) => {
    await privateFetch
        .patch(`reply/v1/backoffice/flow/${flowId}/activate`, {}, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        })
        .catch((error) => {
            throw new Error(error)
        });
}


export const FlowCreateRequest = async (name, description) => {
    let responseData = {}
    await privateFetch
        .post(`reply/v1/backoffice/flow`, { name, description }, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        })
        .then(async (response) => {
            responseData = await response.data.data
        })
        .catch((error) => {
            throw new Error(error)
        });

    return responseData
}


export const DeleteAiConversationHistory = async (identifier) => {
    await privateFetch
        .delete(`reply/v1/chat/history/${identifier}`, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        })
        .catch((error) => {
            throw new Error(error)
        });
}


export const saveFlowConfiguration = async (bodyRequest) => {
    let responseData = {}
    await privateFetch.post('reply/v1/backoffice/flow/graph', bodyRequest, {
        headers: {
            ...CONSTANT.HEADER_TYPE,
        }
    })
    .then(async (response) => {
        responseData = await response.data
    })
    .catch((error) => {
        throw new Error(error)
    });
    return responseData;
};
